module.exports = __webpack_public_path__ + "img/logo_btn.6083c933.png";